<div class="promotion-code-child-component">
  <h5>Promotion Display Name</h5>
  <div class="promotion-code-child-component-content">
    <div class="currency-row">
      <p>Currency:</p>
      <span *ngIf="currenciesLoading" class="text-muted ml-2">
        <i class="spinner-border spinner-border-sm align-middle mr-1"></i>Loading currencies...
      </span>
      <ul>
        <li *ngFor="let currency of dropdown.currencies" 
          [class.active]="activeCurrencyId === currency.id" 
          (click)="selectCurrency(currency.id)">
          {{ currency.name }}
        </li>
      </ul>
    </div>
    <div *ngIf="localesLoading" class="text-muted mt-2">
      <i class="spinner-border spinner-border-sm align-middle mr-1"></i>Loading locales...
    </div>
    <div *ngIf="activeCurrencyId && filteredLocales" class="locales-table">
      <form [formGroup]="form">
        <div class="row" *ngFor="let locale of filteredLocales | async">
          <div class="col-4 mb-4">
            <span class="kt-font-bold">Locale <span class="text-danger">*</span></span>
            <input class="form-control" type="text" [placeholder]="locale.code" disabled/>
          </div>

          <div class="col-4 mb-4">
            <span class="kt-font-bold">Promotion Name</span>
            <input class="form-control" type="text" [formControl]="getPromotionNameControl(locale.id)" (input)="onPromotionNameInput($event, locale.id)">
            <ng-container *ngIf="initialData.promotion_type == 'BTG Promotion'">
              <span class="reminder-text">
                Phase 1: {{ promotionNamePreviews[locale.id] }}-BTG-Phase-1 <br>
                Phase 2: {{ promotionNamePreviews[locale.id] }}-BTG-Phase-2
              </span>
            </ng-container>
            <ng-container *ngIf="initialData.promotion_type == 'PP Promotion'">
              <span class="reminder-text">
                Phase 1: {{ promotionNamePreviews[locale.id] }}-PP-Phase-1 <br>
                Phase 2: {{ promotionNamePreviews[locale.id] }}-PP-Phase-2
              </span>
            </ng-container>
          </div>

          <div class="col-4 mb-4">
            <span class="kt-font-bold">Rewards Name</span>
            <input class="form-control" type="text" [formControl]="getRewardNameControl(locale.id)" (input)="onRewardNameInput($event, locale.id)">
          </div>
        </div>
      </form>
    </div>
  </div>
</div>